module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__stock__workers"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": 1,
      "table-id": "stock-workers",
      "link": ""
    },
    on: {
      "refresh": _vm.getResponsibles,
      "create": _vm.addUser
    },
    scopedSlots: _vm._u([{
      key: "groups",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "chips"
        }, _vm._l((scope.item.groups), function(item) {
          return _c('div', {
            staticClass: "chip"
          }, [_vm._v(" " + _vm._s(item.name) + " ")])
        }))]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }, {
      key: "buttons",
      fn: function(scope) {
        return [_c('md-button', {
          staticClass: "md-dense",
          on: {
            "click": _vm.back
          }
        }, [_c('md-icon', [_vm._v("keyboard_backspace")]), _vm._v("Вернуться к складам")], 1), _vm._v(" "), _c('md-button', {
          staticClass: "md-dense",
          on: {
            "click": _vm.addUser
          }
        }, [_vm._v("Добавить"), _c('md-icon', [_vm._v("add")])], 1)]
      }
    }]),
    model: {
      value: (_vm.responsibles),
      callback: function($$v) {
        _vm.responsibles = $$v
      },
      expression: "responsibles"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e26a92f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/StockWorkers.vue
// module id = 1268
// module chunks = 0